<app-steps [current]="stepAtual()" [total]="totalSteps()"></app-steps>
<h2 class="title">Resumo</h2>

<div class="dados-cadastrais">
  @for (tabela of [dadosPessoais(), dadosRecebimento()]; track $index) {
    <table>
      <tbody>
        @for (linha of tabela; track linha.rotulo) {
          <tr>
            <td>{{ linha.rotulo }}</td>
            <td class="valor">{{ linha.valor }}</td>
          </tr>
        }
      </tbody>
    </table>
  }
</div>

@if (antecipacao(); as antecipacao) {
  <div class="detalhes antecipacao">
    <h3 class="subtitulo">Antecipação do benefício</h3>
    <table>
      <tbody>
        <tr>
          <td>Valor Bruto da antecipação do saldo</td>
          <td class="valor">
            R$ {{ formatarValor(antecipacao.valorBruto) }} ({{ formatarNumero(antecipacao.percentual) }}%)
          </td>
        </tr>
        <tr>
          <td>Valor do Imposto de Renda da antecipação do saldo</td>
          <td class="valor">R$ {{ formatarValor(antecipacao.valorImpostoRenda) }}</td>
        </tr>
        <tr class="valor-liquido">
          <td>Valor Líquido da antecipação do saldo</td>
          <td class="valor">
            <span class="valor-liquido__total"><span class="moeda">R$</span> {{ formatarValor(antecipacao.valorLiquido) }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
}

@if (valores(); as valores) {
  <div class="detalhes beneficio">
    <h3 class="subtitulo">Benefício</h3>
    <table>
      <tbody>
        <tr>
          <td>Saldo geral</td>
          <td class="valor">R$ {{ formatarValor(saldoGeral()) }}</td>
        </tr>
        <tr>
          <td>Valor Bruto Mensal (estimado)</td>
          <td class="valor">R$ {{ formatarValor(valores.valorBrutoMensal) }}</td>
        </tr>
        <tr>
          <td>Valor do Imposto de Renda (estimado)</td>
          <td class="valor valor--desconto">
            R$ {{ formatarValor(valores.valorImpostoRenda) }} ({{ formatarNumero(valores.percentualImpostoRenda) }}%)
          </td>
        </tr>
        <tr class="valor-liquido">
          <td>Valor Líquido Mensal do Benefício (estimado)</td>
          <td class="valor">
            <span class="valor-liquido__total"><span class="moeda">R$</span> {{ formatarValor(valores.valorLiquidoMensal) }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
}

<div class="d-flex justify-content-center align-items-center buttons-requerimento">
  <vivest-button variant="outline" size="md" (click)="onReturn()">
    Voltar
  </vivest-button>
  <vivest-button variant="primary" size="md" (click)="onSubmit()">
    <vivest-icon slot="icon-right" name="arrow-right" source="feather"></vivest-icon>
    Continuar para assinatura do termo
  </vivest-button>
</div>
